import { useCallback, useState } from 'react';

/**
 * A remembered yes/no, surviving a browser that refuses storage.
 *
 * What an "About" panel and the like use to stay closed once closed: a
 * screen has to teach once, then stay out of the way. Per browser, never
 * sent anywhere.
 */
export function useRemembered(key: string, fallback: boolean): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState<boolean>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? fallback : stored === 'open';
    } catch {
      return fallback;
    }
  });
  const set = useCallback(
    (next: boolean) => {
      setValue(next);
      try {
        localStorage.setItem(key, next ? 'open' : 'closed');
      } catch {
        /* a private window: remembered for this visit only */
      }
    },
    [key],
  );
  return [value, set];
}
